import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import useResetPassword from "@/hooks/useResetPassword";
import { ConfirmResetPasswordForm, RequestResetCodeForm } from "@/components/resetPassword";


const ResetPasswordWizard = () => {
  const {
    loading,
    step,
    email,
    handleRequestResetCode,
    handleConfirmResetPassword,
    goBackToRequest,
  } = useResetPassword();

  return (
    <div className="min-h-full bg-gray-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-xl">
        <CardHeader className="text-center pb-6">
          <CardTitle className="text-2xl font-semibold">
            {step === "request" ? "Reset Password" : "Enter New Password"}
          </CardTitle>
          <CardDescription className="text-gray-600">
            {step === "request"
              ? "Enter your email address and we'll send you a verification code"
              : "Enter the verification code and your new password"}
          </CardDescription>
        </CardHeader>

        <CardContent>
          {step === "request" ? (
            <RequestResetCodeForm
              onSubmit={handleRequestResetCode}
              loading={loading}
            />
          ) : (
            <ConfirmResetPasswordForm
              email={email}
              onSubmit={handleConfirmResetPassword}
              onBack={goBackToRequest}
              loading={loading}
            />
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default ResetPasswordWizard;
